export default __webpack_public_path__ + "static/media/icon_user_outline.9d53d6a6.svg";